<template>
  <div>HERE</div>
</template>

<script>
export default {
  name: 'SelectedMultipleOpenTables',
  data ()   {
    return {}
  }
}
</script>